<template>
  <v-form>
    <v-container fluid>
      <v-row>


        <v-col cols="12" sm="6" md="6">
          <p>Format : x.x.x (1.0.0, 1.2.1, 1.0.0-ALPHA.1, 1.0.0-R.1, ...)</p>
          <v-text-field
            v-model="item.version"
            :error-messages="versionErrors"
            :label="$t('profile.tool.version')"
            required
            @input="$v.item.version.$touch()"
            @blur="$v.item.version.$touch()"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6"  v-if="!item['@id']">
          <v-combobox
            v-if="toolheadSelectItems"
            v-model="item.parent"
            :items="toolheadSelectItems"
            :error-messages="parentErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            :label="$t('profile.tool.parent')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="machineSelectItems"
            v-model="item.machine"
            :items="machineSelectItems"
            :error-messages="machineErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            multiple
            :label="$t('profile.machine.machine')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="materialSupplySelectItems"
            v-model="item.materialSupply"
            :items="materialSupplySelectItems"
            :error-messages="materialSupplyErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            multiple
            :label="$t('profile.setupdefinition.materialsupply')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <strong class="ml-4" >{{ $t('global.archive') }}:</strong>
          <v-switch
                v-model="item.archive"
                :error-messages="archiveErrors"
              ></v-switch>
        </v-col>
      </v-row>
    </v-container>
        <Loading :visible="isLoading" />
  </v-form>
</template>

<script>
import has from 'lodash/has';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';

export default {
  name: 'ToolHeadForm',
  mixins: [validationMixin],
  components: {
    Loading
  },
  props: {
    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
      this.machineGetSelectItems();
      this.toolHeadSubsGetSelectItems();
      this.materialSupplyGetSelectItems();
      this.toolheadGetSelectItems({'query'  : [{'id': 'exists[parent]', 'value': 0 }]  });
  },
  data() {
    return {

        version: null,
        parent: null,
        toolHeadSubs: null,
        machine: null,
        materialSupply: null,
    };
  },
  computed: {
    isLoading() {
      return (this.isLoading_machine ||
          this.isLoading_toolhead ||
          this.isLoading_materialSupply ||
         this.isLoading_toolheadsub
       );
    },
      ...mapFields('machine', {
        machineSelectItems: 'selectItems',
        isLoading_machine : 'isLoading'
      }),
      ...mapFields('materialsupply', {
        materialSupplySelectItems: 'selectItems',
        isLoading_materialSupply : 'isLoading'
      }),
      ...mapFields('toolhead', {
        toolheadSelectItems: 'selectItems',
        isLoading_toolhead : 'isLoading'
      }),
      ...mapFields('toolheadsub', {
        toolHeadSubsSelectItems: 'selectItems',
        isLoading_toolheadsub : 'isLoading'
      }),

    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },


    versionErrors() {
      const errors = [];

      if (!this.$v.item.version.$dirty) return errors;

      has(this.violations, 'version') && errors.push(this.violations.version);

      !this.$v.item.version.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    machineErrors() {
      const errors = [];

      if (!this.$v.item.machine.$dirty) return errors;

      has(this.violations, 'machine') && errors.push(this.violations.machine);


      return errors;
    },
    materialSupplyErrors() {
      const errors = [];

      if (!this.$v.item.materialSupply.$dirty) return errors;

      has(this.violations, 'materialSupply') && errors.push(this.violations.materialSupply);


      return errors;
    },
    parentErrors() {
      const errors = [];

      if (!this.$v.item.parent.$dirty) return errors;

      has(this.violations, 'parent') && errors.push(this.violations.parent);


      return errors;
    },
    toolHeadSubsErrors() {
      const errors = [];

      if (!this.$v.item.toolHeadSubs.$dirty) return errors;

      has(this.violations, 'toolHeadSubs') && errors.push(this.violations.toolHeadSubs);


      return errors;
    },

    violations() {
      return this.errors || {};
    }
  },
  methods: {
      ...mapActions({
        machineGetSelectItems: 'machine/fetchSelectItems'
      }),
      ...mapActions({
        toolheadGetSelectItems: 'toolhead/fetchSelectItems'
      }),
      ...mapActions({
        toolHeadSubsGetSelectItems: 'toolheadsub/fetchSelectItems'
      }),
      ...mapActions({
        materialSupplyGetSelectItems: 'materialsupply/fetchSelectItems'
      }),
  },
  validations: {
    item: {
      version: {
        required,
      },
      machine: {
      },
      parent: {
      },
      toolHeadSubs: {
      },
      materialSupply: {
      },
    }
  }
};
</script>
